import {
  TARGETINGS_ALL_REQUESTED,
  TARGETINGS_ALL_FAIL,
  TARGETINGS_ALL_OK,
} from "actions/targeting";

const INITIAL_STATE = {
  loading: false,
  targetings: {
    loadingOs: false,
    errorOs: false,
    os: [],
    os_type: [
      { key: 1, title: "Desktop" },
      { key: 2, title: "Mobile" },
      { key: 3, title: "Other" },
    ],
    loadingDevice: false,
    errorDevice: false,
    device: [],
    loadingBrowser: false,
    errorBrowser: false,
    browser: [],
    loadingLanguage: false,
    errorLanguage: false,
    language: [],
    device_type: [
      { key: 1, title: "Desktop" },
      { key: 2, title: "Other" },
      { key: 3, title: "Phone" },
      { key: 4, title: "Tablet" },
      { key: 5, title: "TV" },
    ],
  },
  cities: [],
  citiesByQuery: [],
  regions: [],
  regionsByQuery: [],
  errors: [],
};

export function targetingReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case "GET_LANGUAGE_ERROR": {
      return {
        ...state,
        targetings: {
          ...state.targetings,
          loadingLanguage: false,
          errorLanguage: true,
        },
      };
    }

    case "GET_LANGUAGE_LOADING": {
      return {
        ...state,
        targetings: {
          ...state.targetings,
          loadingLanguage: true,
        },
      };
    }

    case "GET_LANGUAGE_OK": {
      return {
        ...state,
        targetings: {
          ...state.targetings,
          language: action.data.data,
          loadingLanguage: false,
          errorLanguage: false,
        },
      };
    }

    case "GET_BROWSER_ERROR": {
      return {
        ...state,
        targetings: {
          ...state.targetings,
          loadingBrowser: false,
          errorBrowser: true,
        },
      };
    }

    case "GET_BROWSER_LOADING": {
      return {
        ...state,
        targetings: {
          ...state.targetings,
          loadingBrowser: true,
        },
      };
    }

    case "GET_BROWSER_OK": {
      return {
        ...state,
        targetings: {
          ...state.targetings,
          browser: action.data.data,
          loadingBrowser: false,
          errorBrowser: false,
        },
      };
    }

    case "GET_DEVICE_ERROR": {
      return {
        ...state,
        targetings: {
          ...state.targetings,
          errorDevice: true,
          loadingDevice: false,
        },
      };
    }

    case "GET_DEVICE_LOADING": {
      return {
        ...state,
        targetings: {
          ...state.targetings,
          loadingDevice: true,
        },
      };
    }

    case "GET_DEVICE_OK": {
      return {
        ...state,
        targetings: {
          ...state.targetings,
          device: action.data.data,
          loadingDevice: false,
          errorDevice: false,
        },
      };
    }

    case "GET_OS_ERROR": {
      return {
        ...state,
        targetings: {
          ...state.targetings,
          errorOs: true,
          loadingOs: false,
        },
      };
    }

    case "GET_OS_LOADING": {
      return {
        ...state,
        targetings: {
          ...state.targetings,
          loadingOs: true,
        },
      };
    }

    case "GET_OS_OK": {
      return {
        ...state,
        targetings: {
          ...state.targetings,
          os: action.data.data,
          loadingOs: false,
          errorOs: false,
        },
      };
    }

    case TARGETINGS_ALL_REQUESTED:
      return {
        ...INITIAL_STATE,
        loading: true,
      };

    case TARGETINGS_ALL_OK:
      return {
        ...INITIAL_STATE,
        loading: false,
        targetings: {
          ...state.targetings,
          ...action.data,
        },
      };

    case TARGETINGS_ALL_FAIL:
      return {
        ...INITIAL_STATE,
        loading: true,
        errors: action.errors,
      };

    default:
      return state;
  }
}
